export default "__VITE_ASSET__DqzQOjki__"